import { render } from "./GenericListComponent.vue?vue&type=template&id=9769c72a&ts=true"
import script from "./GenericListComponent.vue?vue&type=script&lang=ts"
export * from "./GenericListComponent.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__